import React from 'react';
import { Link } from 'react-router-dom';

const Service: React.FC = () => {
  return (
    <div className="container-fluid service py-5">
      <div className="container py-5">
        <div className="d-flex flex-column mx-auto text-center mb-5 wow fadeInUp" data-wow-delay="0.2s"
          style={{ maxWidth: "800px" }}>
          <h4 className="text-primary">Our Services</h4>
          <h1 className="display-4 mb-4">The Best Service For You</h1>
          <p className="mb-0">At Wasser Technochem, we deliver the best service tailored to your water and wastewater
            treatment needsâ€"combining expert solutions, reliable support, and a commitment to efficiency and
            sustainability for your peace of mind.
          </p>
        </div>
        <div className="row g-5 align-items-center">
          <div className="col-lg-3 wow fadeInLeft" data-wow-delay="0.2s">
            <ul className="nav">
              <li className="nav-item me-lg-0 mb-4">
                <Link className="py-3 px-5 active" data-bs-toggle="pill" to="#ServiceTab-1">
                  <span>Industrial</span>
                </Link>
              </li>
              <li className="nav-item me-lg-0 mb-4">
                <Link className="py-3 px-5" data-bs-toggle="pill" to="#ServiceTab-2">
                  <span>Municipal</span>
                </Link>
              </li>
              <li className="nav-item me-lg-0 mb-4 ">
                <Link className="py-3 px-5" data-bs-toggle="pill" to="#ServiceTab-3">
                  <span>Hotels & Hospitals</span>
                </Link>
              </li>
              <li className="nav-item me-lg-0 mb-4 mb-lg-0">
                <Link className="py-3 px-5" data-bs-toggle="pill" to="#ServiceTab-4">
                  <span>Residential Complexes</span>
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-9 wow fadeInRight" data-wow-delay="0.3s">
            <div className="tab-content">
              <div id="ServiceTab-1" className="tab-pane fade show p-0 active">
                <div className="service-carousel owl-carousel">
                  <div className="service-item">
                    <img src="img/commercial-1.jpg" className="img-fluid w-100" alt="" />
                    <div className="border border-top-0 p-4">
                      <h4 className="mb-3">Water & Wastewater Treatment Plants</h4>
                      <p className="mb-4">We offer end-to-end water treatment solutions tailored to industrial requirements â€" from WTPs and De-Mineralised (DM) systems for WHRBs to RO plants for process industries. Our expertise extends to Effluent Treatment Plants (ETP) and Zero Liquid Discharge (ZLD) systems for textile and chemical industries, as well as large-scale Sewage Treatment Plants (STP) designed for industrial townships and estates.
                      </p>
                      <Link className="btn btn-primary py-2 px-4" to="/water-treatment-plants">Read More</Link>
                    </div>
                  </div>
                  <div className="service-item">
                    <img src="img/commercial-2.jpg" className="img-fluid w-100" alt="" />
                    <div className="border border-top-0 p-4">
                      <h4 className="mb-3">Specialty Chemicals</h4>
                      <p className="mb-4">Our in-house SANYOLÂ® WT specialty chemicals are formulated to address complex industrial water challenges. Our range includes RO antiscalants, cooling tower corrosion inhibitors and biocides, boiler treatment solutions including AVT, and ETP/STP coagulants, flocculants, and sludge conditioners â€" all backed by technical support and field expertise.
                      </p>
                      <Link className="btn btn-primary py-2 px-4" to="/sanyol-wt-specility-chemicals">Read More</Link>
                    </div>
                  </div>
                </div>
              </div>
              <div id="ServiceTab-2" className="tab-pane fade show p-0">
                <div className="service-carousel owl-carousel">
                  <div className="service-item">
                    <img src="img/residential-1.jpg" className="img-fluid w-100" alt="" />
                    <div className="border border-top-0 p-4">
                      <h4 className="mb-3">City WTP/STP</h4>
                      <p className="mb-4">We specialize in delivering complete mechanical, electrical, and automation solutions for Water Treatment Plants (WTPs) and Sewage Treatment Plants (STPs) under municipal projects. Our scope includes design, supply, installation, and commissioning of pumps, blowers, diffusers, MCC panels, PLC-SCADA systems, and instrumentation â€" all tailored for long-term, compliant operation.
                      </p>
                      <Link className="btn btn-primary py-2 px-4" to="/water-treatment-plants">Read More</Link>
                    </div>
                  </div>
                  <div className="service-item">
                    <img src="img/residential-2.jpg" className="img-fluid w-100" alt="" />
                    <div className="border border-top-0 p-4">
                      <h4 className="mb-3">Operation & Maintenance (O&M)</h4>
                      <p className="mb-4">WTIL is actively involved in the Operation & Maintenance (O&M) of large public-sector sewage treatment infrastructure, with experience under national initiatives such as Namami Gange. We ensure continuous compliance with discharge norms, preventive maintenance, and efficiency optimization through trained manpower and digital monitoring systems.
                      </p>
                      <Link className="btn btn-primary py-2 px-4" to="/operation-and-maintenance">Read More</Link>
                    </div>
                  </div>
                </div>
              </div>
              <div id="ServiceTab-3" className="tab-pane fade show p-0">
                <div className="service-carousel owl-carousel">
                  <div className="service-item">
                    <img src="img/industrial-1.jpg" className="img-fluid w-100" alt="" />
                    <div className="border border-top-0 p-4">
                      <h4 className="mb-3">Compact STP & Water Recycling Systems</h4>
                      <p className="mb-4">We design and install space-efficient STPs ideal for hospitality and healthcare facilities, ensuring hygienic wastewater treatment and treated water reuse for landscaping or flushing, helping clients meet green building norms.
                      </p>
                      <Link className="btn btn-primary py-2 px-4" to="/wastewater-treatment-solutions">Read More</Link>
                    </div>
                  </div>
                  <div className="service-item">
                    <img src="img/industrial-2.jpg" className="img-fluid w-100" alt="" />
                    <div className="border border-top-0 p-4">
                      <h4 className="mb-3">Potable Water & Filtration Systems</h4>
                      <p className="mb-4">Integrated water purification systems including multi-grade filters, activated carbon units, softeners, UV/RO systems, and storage tank disinfection solutions for consistently safe and high-quality water for guests and patients.
                      </p>
                      <Link className="btn btn-primary py-2 px-4" to="/water-treatment-plants">Read More</Link>
                    </div>
                  </div>
                </div>
              </div>

              <div id="ServiceTab-3" className="tab-pane fade show p-0">
                <div className="service-carousel owl-carousel">
                  <div className="service-item">
                    <img src="img/industrial-1.jpg" className="img-fluid w-100" alt="" />
                    <div className="border border-top-0 p-4">
                      <h4 className="mb-3">Modular STPs & Greywater Reuse</h4>
                      <p className="mb-4">Our plug-and-play STPs are ideal for residential societies, offering effective sewage treatment and greywater reuse solutions. Systems are designed for low footprint, odor control, and silent operation.
                      </p>
                      <Link className="btn btn-primary py-2 px-4" to="/wastewater-treatment-solutions">Read More</Link>
                    </div>
                  </div>
                  <div className="service-item">
                    <img src="img/industrial-2.jpg" className="img-fluid w-100" alt="" />
                    <div className="border border-top-0 p-4">
                      <h4 className="mb-3">Water Filtration & Softening Units</h4>
                      <p className="mb-4">We offer domestic water softeners, iron removal filters, and activated carbon units to treat borewell or municipal water at the building level, ensuring clean water for residents while preventing scale and staining.
                      </p>
                      <Link className="btn btn-primary py-2 px-4" to="/water-treatment-plants">Read More</Link>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
